import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

import { NotificationService } from '../../../../../../../../app/shared/services/notification-service/notification.service';
import { ReportingService } from '../../../../../../../../app/shared/services/reporting-service/reporting.service';
import { PlanningReportService } from '../../../../../../../../app/services/property-matrixV2/services';
import { DiagramAndPlanDto } from '../../../../../../../../app/services/property-matrixV2/models';

@Component({
  selector: 'app-sg-diagram-and-plan',
  templateUrl: './sg-diagram-and-plan.component.html',
  styleUrls: ['./sg-diagram-and-plan.component.scss', '../../../../../../../../css/2-modules/_admin-portal.scss']
})
export class SgDiagramAndPlanComponent implements OnInit {

  @Input() addendumTwoId: string;
  @Output() diagramAndPlanChange = new EventEmitter<DiagramAndPlanDto[]>();

  diagramAndPlanData: DiagramAndPlanDto[] = [];

  file: any;
  fileId: string | null = null;
  fileUrls: string[] = [];
  hideButtons: boolean = false;

  maxDiagramsAndPlans: number = 9;

  constructor(
    private reportingService: ReportingService,
    private notificationService: NotificationService,
    private planningReportService: PlanningReportService
  ) { }

  ngOnInit(): void {
    this.loadDiagramAndPlanDetails();
  }

  async setFile(event: { target: { files: any[]; }; }, index: number): Promise<void> {
    try {
      this.fileId = await this.reportingService.uploadFile(event.target.files[0]);
      this.diagramAndPlanData[index].imageUrl = this.fileId;
      this.emitChanges();

      this.file = event.target.files[0];

      var reader = new FileReader();

      reader.onload = (event: any) => {
        this.fileUrls[index] = event.target.result;
        this.hideButtons = true;
      }

      reader.readAsDataURL(this.file);
    } catch (error) {
      this.notificationService.showErrorMessage('Error', 'Could not upload file.');
    }
  }

  async loadFile(index: number): Promise<void> {
    const diagramAndPlan = this.diagramAndPlanData[index];
    if (diagramAndPlan.imageUrl) {
      try {
        const fileUrl = await this.reportingService.getFileUrl(diagramAndPlan.imageUrl);
        this.fileUrls[index] = fileUrl;
        this.hideButtons = !!fileUrl;
        this.emitChanges();
      } catch (error) {
        this.notificationService.showErrorMessage('Error', 'Could not load file.');
      }
    }
  }

  async loadAllFiles(): Promise<void> {
    for (let i = 0; i < this.diagramAndPlanData.length; i++) {
      await this.loadFile(i);
    }
  }

  addItemToArray(array: any[], item: any): void {
    array.push(item);
    this.emitChanges();
  }

  removeItemFromArray(array: any[], index: number): void {
    if (index >= 0 && index < array.length) {
      array.splice(index, 1);
      this.emitChanges();
    }
  }

  createDiagramAndPlan(): void {
    const newDiagramAndPlan: DiagramAndPlanDto = {
      id: uuidv4(),
      imageName: '',
      imageUrl: ''
    };
    this.addItemToArray(this.diagramAndPlanData, newDiagramAndPlan);
  }

  addDiagramAndPlan(): void {
    if (this.diagramAndPlanData.length < this.maxDiagramsAndPlans) {
      this.createDiagramAndPlan();
    } else {
      this.notificationService.showWarningMessage('Diagram And Plan Limit Reached', 'You cannot add more than ' + this.maxDiagramsAndPlans + ' diagrams and plans.');
    }
  }

  async removeDiagramAndPlan(index: number): Promise<void> {
    const confirmed = await this.notificationService.showConfirmMessage(
      'Confirm Deletion',
      'Are you sure you want to remove this item? This action cannot be undone.',
      'Remove',
      'Cancel'
    );

    if (!confirmed) {
      return;
    }

    this.removeItemFromArray(this.diagramAndPlanData, index);
    this.fileUrls.splice(index, 1);
  }

  loadDiagramAndPlanDetails(): void {
    this.planningReportService.apiV1PlanningReportGetDiagramsAndPlansGet({
      addendumTwoId: this.addendumTwoId
    }).subscribe({
      next: async (response) => {
        this.diagramAndPlanData = response;
        if (this.diagramAndPlanData === null || this.diagramAndPlanData.length === 0) {
          this.createDiagramAndPlan();
        } else {
          await this.loadAllFiles();
        }
        this.emitChanges();
      },
      error: (_error: any) => {
        this.notificationService.showErrorMessage('Error', 'Could not load diagrams and plans.');
      }
    });
  }

  emitChanges(): void {
    this.diagramAndPlanChange.emit(this.diagramAndPlanData);
  }

  replace(index: number): void {
    this.hideButtons = false;
    this.fileUrls[index] = "";
    this.fileId = "";
    this.diagramAndPlanData[index].imageUrl = null;
  }
}
